import React from 'react';
import PropTypes from 'prop-types';
import StepHeader from '../step-header';
import StepWrapper from './step-wrapper';
var InfoStep = function InfoStep(_ref) {
  var content = _ref.content,
    onNextClick = _ref.onNextClick;
  return /*#__PURE__*/React.createElement(StepWrapper, {
    backgroundImage: content.BackgroundImage,
    stepClassNames: "step--info"
  }, /*#__PURE__*/React.createElement(StepHeader, {
    icon: content.StepHeaderIcon,
    header: content.StepHeaderTitle
  }), /*#__PURE__*/React.createElement("h1", {
    className: "step__title"
  }, content.Heading), /*#__PURE__*/React.createElement("p", {
    className: "step__body"
  }, content.Body), /*#__PURE__*/React.createElement("button", {
    className: "step-button",
    onClick: function onClick(e) {
      e.preventDefault();
      onNextClick();
    }
  }, content.NextButtonLabel));
};
InfoStep.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object.isRequired,
  onNextClick: PropTypes.func.isRequired
};
export default InfoStep;